/**
 * Lead-intake webhook configuration.
 *
 * The public webhook URL for the lead-intake edge function. Resolution order:
 *   1. VITE_LEAD_INTAKE_URL (explicit override)
 *   2. derived from VITE_SUPABASE_URL (works automatically on any project)
 *   3. hardcoded project default (last resort)
 *
 * To deploy against another Supabase project, just set VITE_SUPABASE_URL (which
 * the app already needs) — the webhook URL follows automatically.
 */
const explicit = import.meta.env.VITE_LEAD_INTAKE_URL as string | undefined;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const DEFAULT_LEAD_INTAKE_URL =
  'https://giedkdxtrqcqzcockacd.supabase.co/functions/v1/lead-intake';

export const LEAD_INTAKE_URL: string =
  explicit ||
  (supabaseUrl ? `${supabaseUrl.replace(/\/$/, '')}/functions/v1/lead-intake` : DEFAULT_LEAD_INTAKE_URL);
